import React, { useState, useCallback, useMemo } from 'react';
import { Collection } from '@components/common';
import { useLanguage } from '@contexts/LanguageContext';
import './ResourcesPage.scss';

export const ResourcesPage = () => {
    const { t } = useLanguage();
    const [refreshTrigger, setRefreshTrigger] = useState(0);

    const handleRefresh = useCallback(() => {
        setRefreshTrigger(prev => prev + 1);
    }, []);

    // Custom filters - Collection will automatically fetch categories
    const filterOptions = useMemo(() => [
        {
            key: 'category_ids',
            label: t('resources.filters.category'),
            type: 'multiselect',
            icon: 'layer-group',
            // options will be auto-populated by Collection using categories data
        },
        {
            key: 'location_id',
            label: t('reservation.location'),
            type: 'select',
            icon: 'map-marker-alt',
            // options will be auto-populated by Collection using locations data
        },

    ], [t]);

    return (
        <div className="resources-page">
            <Collection
                modelName="resources"
                displayType="grid"
                title={t('resources.title')}
                description={t('resources.subtitle')}
                enableSearch={true}
                searchFields={['name', 'description']}
                filterOptions={filterOptions}
                sortFields={[
                    { key: 'name', label: t('resources.name') },
                    { key: 'created_at', label: t('common.createdAt') },
                    { key: 'updated_at', label: t('common.updatedAt') }
                ]}
                refreshTrigger={refreshTrigger}
                onRefresh={handleRefresh}
                className="resources-collection"
                showHorizontalCategoryFilter={true} // Enable horizontal category filter
            />
        </div>
    );
};

export default ResourcesPage;